import * as API from "../../api"
import * as ActionTypes from "../action-types";
import { REDUX } from '../../../constants'
import { message } from "antd";

import {
    get_devices_mdvr_request
} from './devicesMDVR'

/**
 * Get Device Groups
 */

 export const get_device_mdvr_groups_request = (mdvrgids, uid = null) => dispatch => {

    let mdvrgidBatch = []

    mdvrgids.map((mdvrgid, index) => {

        mdvrgidBatch.push(mdvrgid)

        if( 
            (index+1) % REDUX.REDUX_DEVICE_GROUP_BATCH_GET_SIZE === 0
            ||
            index+1 === mdvrgids.length
        ) {
            dispatch(batch_get_device_mdvr_groups_request(mdvrgidBatch, uid))
            mdvrgidBatch = []
        }

        return null
    })
 }

/**
 * Batch Get Device Groups
 */
 export const batch_get_device_mdvr_groups_request = (mdvrgids, uid = null) => dispatch => {

    API
    .getDeviceMDVRGroupBatch(mdvrgids)
    .then(info => {

        try {
            const {
                mobileDeviceVideoRecorderGroups
            } = info

            dispatch(batch_get_device_mdvr_groups_success(mobileDeviceVideoRecorderGroups, uid))

            mobileDeviceVideoRecorderGroups 
            && mobileDeviceVideoRecorderGroups.length 
            && dispatch(
                get_devices_mdvr_request(
                    mobileDeviceVideoRecorderGroups.reduce((acc, cur) => [...acc, ...cur.devices], [])
                )
            )


        } catch(err) {
            console.log(`Error`, err)
            message.error('Error in batch getting device groups. Refresh page?')
        }

    })
}

const batch_get_device_mdvr_groups_success = (mdvrGroups, uid = null) => {
    return {
        type: ActionTypes.GET_DEVICE_MDVR_GROUPS,
        mdvrGroups,
        uid
    };
}
